module.exports = __webpack_public_path__ + "img/game.9a9f0b3c.svg";